import MuiAutocomplete from '@mui/joy/Autocomplete';

import { withBaseSelectStyle } from '@components/BaseStyledComponents/BaseSelect';

export const BaseAutocomplete: typeof MuiAutocomplete =
  withBaseSelectStyle(MuiAutocomplete);
